// Форматтеры для админ-таблицы. Целые числа группируем тонким пробелом
// (ru-RU), деньги адаптивно — траты на генерацию бывают в копейках.

const intFmt = new Intl.NumberFormat('ru-RU');

export const fmtInt = (n: number): string => intFmt.format(Math.round(n));

/** Рубли адаптивно: траты на генерацию — копейки, у малых сумм оставляем две значащие цифры
 *  (0,021 ₽), у сумм до сотни — копейки, дальше — целые. */
export function fmtRub(n: number): string {
  if (!n) return '0 ₽';
  const opts: Intl.NumberFormatOptions =
    n < 1 ? { maximumSignificantDigits: 2 } : { maximumFractionDigits: n < 100 ? 2 : 0 };
  return `${new Intl.NumberFormat('ru-RU', opts).format(n)} ₽`;
}

export const fmtPct = (share: number): string => `${Math.round(share * 100)}%`;

const localeFor = (lang: string): string => (lang.startsWith('en') ? 'en-US' : 'ru-RU');

export function fmtDate(iso: string, lang: string): string {
  return new Date(iso).toLocaleDateString(localeFor(lang), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function fmtDateTime(iso: string, lang: string): string {
  return new Date(iso).toLocaleString(localeFor(lang), {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** Календарный день YYYY-MM-DD (день по Москве с бэка) без перевода часового пояса:
 *  `new Date('2026-10-12')` — это полночь UTC, и западнее UTC браузер показал бы 11-е. */
export function fmtCalendarDay(day: string, lang: string, month: 'short' | 'long' = 'short'): string {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(localeFor(lang), { day: 'numeric', month });
}
